import { ServerConfig } from "@/config/config";
import { AdminDepartment } from "@/models/admin-department";
import { Department } from "@/utils/department";
import { Axios } from "./auth-service";

export class SettingsServiceClass {
	public readonly URL:string = `${ServerConfig.host}/admin/settings`
	public readonly DEPARTMENTS_URL:string = `${this.URL}/departments`
	public readonly TICKET_EMAIL_NOTIFICATIONS_URL:string = `${this.URL}/ticket-email-notifications`

	async getJoinedDepartments():Promise<AdminDepartment[]> {
		let result = await Axios.get(`${this.DEPARTMENTS_URL}`);
		return result.data.map((d:any) => new AdminDepartment(d));
	}
	async joinDepartment(department:Department):Promise<AdminDepartment> {
		let result = await Axios.post(`${this.DEPARTMENTS_URL}/join/${department}`);
		return new AdminDepartment(result.data);
	}
	async leaveDepartment(department:Department):Promise<AdminDepartment> {
		let result = await Axios.post(`${this.DEPARTMENTS_URL}/leave/${department}`);
		return new AdminDepartment(result.data);
	}

	async isSubscribedToTicketNotifications():Promise<boolean>{
		let result = await Axios.get(`${this.TICKET_EMAIL_NOTIFICATIONS_URL}/is-subscribed`);
		return result.data.isSubscribed;
	}
	async subscribeToTicketNotifications():Promise<boolean>{
		let result = await Axios.post(`${this.TICKET_EMAIL_NOTIFICATIONS_URL}/subscribe`);
		return result.data.isSubscribed;
	}
	async unsubscribeToTicketNotifications():Promise<boolean>{
		let result = await Axios.post(`${this.TICKET_EMAIL_NOTIFICATIONS_URL}/unsubscribe`);
		return result.data.isSubscribed;
	}

}


export const SettingsService = new SettingsServiceClass();